import { createEdit, fetchEdits } from '../../services/editingApi';

/**
 * Where "Quick edit" on a video or set leads: the newest edit of it, or a new
 * one. One edit per source is what most people want; the studio lists the
 * others later.
 */
export async function quickEditPathFor(source: { videoId?: string; multicamSetId?: string }): Promise<string> {
  const existing = await fetchEdits(source);
  if (existing.length > 0) return `/edit/${existing[0].id}`;
  const created = await createEdit(source);
  return `/edit/${created.id}`;
}
